import Store from "../Store";

const MarketStatementApprovalStore = new Store("markets/statements/approvals");

export { MarketStatementApprovalStore };
